/*
 * PluginSelectionModal Messages
 *
 * This contains all the text for the PluginSelectionModal component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.components.PluginSelectionModal';

export default defineMessages({
  categories: {
    id: `${scope}.categories`,
    defaultMessage: 'Categories',
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: 'CHOOSE A TEMPLATE',
  },
  appTitle: {
    id: `${scope}.title`,
    defaultMessage: 'Add an App',
  },
  courseTitle: {
    id: `${scope}.title`,
    defaultMessage: 'Create a course',
  },
  unitTitle: {
    id: `${scope}.title`,
    defaultMessage: 'Create a unit',
  },
  lessonTitle: {
    id: `${scope}.title`,
    defaultMessage: 'Create a lesson',
  },
  screenTitle: {
    id: `${scope}.title`,
    defaultMessage: 'Add a screen',
  },
  pathwayTitle: {
    id: `${scope}.pathwayTitle`,
    defaultMessage: 'Adaptivity Type',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: 'Each template is simply a starting point that can be customized to fit your subject matter and content.',
  },
  templateTitle: {
    id: `${scope}.templateTitle`,
    defaultMessage: 'Choose a template',
  },
  templateDescription: {
    id: `${scope}.templateDescription`,
    defaultMessage: 'Each template is simply a starting point that can be customized to fit your subject matter and content.',
  },
  placeholder: {
    id: `${scope}.placeholder`,
    defaultMessage: 'Type a name',
  },
  appPlaceholder: {
    id: `${scope}.placeholder`,
    defaultMessage: 'App Name',
  },
  coursePlaceholder: {
    id: `${scope}.coursePlaceholder`,
    defaultMessage: 'Course Name',
  },
  unitPlaceholder: {
    id: `${scope}.unitPlaceholder`,
    defaultMessage: 'Unit Name',
  },
  lessonPlaceholder: {
    id: `${scope}.lessonPlaceholder`,
    defaultMessage: 'Lesson Name',
  },
  screenPlaceholder: {
    id: `${scope}.screenPlaceholder`,
    defaultMessage: 'Screen Name',
  },
  pathwayPlaceholder: {
    id: `${scope}.pathwayPlaceholder`,
    defaultMessage: 'Type a pathway name',
  },
  descriptionPlaceholder: {
    id: `${scope}.descriptionPlaceholder`,
    defaultMessage: 'Type a description',
  },
  courseDescriptionPlaceholder: {
    id: `${scope}.courseDescriptionPlaceholder`,
    defaultMessage: 'Course Description',
  },
  unitDescriptionPlaceholder: {
    id: `${scope}.unitDescriptionPlaceholder`,
    defaultMessage: 'Unit Description',
  },
  lessonDescriptionPlaceholder: {
    id: `${scope}.lessonDescriptionPlaceholder`,
    defaultMessage: 'Lesson Description',
  },
  screenDescriptionPlaceholder: {
    id: `${scope}.screenDescriptionPlaceholder`,
    defaultMessage: 'Screen Description',
  },
  choosePathwayTypes: {
    id: `${scope}.choosePathwayTypes`,
    defaultMessage: 'Choose pathway types',
  },
  courseChoosePathwayTypesDescription: {
    id: `${scope}.courseChoosePathwayTypesDescription`,
    defaultMessage: 'This course plugin requires pathway types to be assigned to define how learners progress.',
  },
  unitChoosePathwayTypesDescription: {
    id: `${scope}.unitChoosePathwayTypesDescription`,
    defaultMessage: 'This unit plugin requires pathway types to be assigned to define how learners progress.',
  },
  lessonChoosePathwayTypesDescription: {
    id: `${scope}.lessonChoosePathwayTypesDescription`,
    defaultMessage: 'This lesson plugin requires pathway types to be assigned to define how learners progress.',
  },
  moreDetailsAboutPathwayTypesLink: {
    id: `${scope}.moreDetailsAboutPathwayTypesLink`,
    defaultMessage: 'More details about pathway types',
  },
});
